// extracted by mini-css-extract-plugin
export default {"dark-mode-btn":"pagination_dark-mode-btn__pwjH0"};